import Navbar from "@components/layout/Navbar";
import { auth } from "@utils/firebase";
import { useLayoutEffect, useMemo } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { Outlet, useLocation } from "react-router-dom";
import { twMerge } from "tailwind-merge";
import SEOHead from "@components/SEO/SEOHead";
import { getSeoDataForRoute } from "@utils/seo";

const Layout = () => {
  const location = useLocation();
  const [userAuth] = useAuthState(auth);

  useLayoutEffect(() => {
    document.documentElement.scrollTo(0, 0);
  }, [location.pathname]);

  const showNavbarOn = useMemo(() => {
    const locationsWithNavbar = ["/", "/my-profile"];

    return !!locationsWithNavbar.includes(location.pathname);
  }, [location]);

  const maxActive = useMemo(() => {
    const locations = [
      "/fact-find",
      "/pension-calculator",
      "/pension-calculator/calculator",
      "/entry",
      "/login",
      "/signup",
      "/forgot-password",
      "/verify/email-verification",
      "/auth/action",
      "/pension-application",
      "/pension-application/activity-details",
      "/pension-application/verify-identity",
      "/pension-application/prsa-form",
      "/pension-application/prsa-form/zurich-provider",
      "/verify/request-followup",
      "/fact-find/qualification",
      "/fact-find/qualification/message",
      "/fact-find/personal-details",
      "/fact-find/financial-details",
      "/fact-find/risk-reward",
      "/fact-find/welcome",
      "/pension-application/activity-details/add-details",
      "/recommendations/details/zurich_standard",
      "/recommendations/details/zurich_nonstandard",
    ];

    return !!locations.includes(location.pathname);
  }, [location]);

  // Get SEO data based on current route
  const seoData = getSeoDataForRoute(location.pathname);

  return (
    <div className="bg-pn_paper-1 w-full mx-auto">
      <SEOHead {...seoData} />
      <div
        className={twMerge(
          maxActive ? "max-w-full" : "max-w-[1440px]",
          "min-h-screen h-full w-full flex flex-col mx-auto"
        )}
      >
        {userAuth && userAuth.emailVerified && showNavbarOn && <Navbar />}
        <Outlet />
      </div>
    </div>
  );
};

export default Layout;